// part of the code extracted from. https://github.com/epeli/underscore.string/blob/master/cleanDiacritics.js
import {ValueObject} from '@s-ui/domain'

const from = 'ąàáäâãåæăćčĉęèéëêĝĥìíïîĵłľńňòóöőôõðøśșşšŝťțţŭùúüűûñÿýçżźž'
const to = 'aaaaaaaaaccceeeeeghiiiijllnnoooooooossssstttuuuuuunyyczzz'.split('')

function replaceCharIfNeeded(char) {
  const index = from.indexOf(char)
  return index === -1 ? char : to[index]
}

/**
 * Temporary Sluglify Value Object until we move to @adv-mt/string
 * TechDebt: https://jira.ets.mpi-internal.com/browse/MTR-107000
 */
export class SluglifyValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  get value() {
    return this.#value
  }

  static create({str, allowQueryParams = false}) {
    const validCharsRegEx = allowQueryParams
      ? /[^a-z0-9\\. \- ? =]/g // only letters numbers, dashes, dots, equals and question marks
      : /[^a-z0-9\\. -]/g // only letters numbers, dashes and dots
    return new SluglifyValueObject({
      value: str
        .toLowerCase()
        .replace(/.{1}/g, replaceCharIfNeeded)
        .replace(validCharsRegEx, '') // remove invalid chars
        .replace(/\s+/g, '_') // collapse whitespace and replace by _
        .replace(/-+/g, '-') // collapse dashes
    })
  }
}
